import React, { useState,useEffect } from 'react'
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Dialog, DialogContent } from '@mui/material';
import appointmentServices from '../appointmentServices';
import { useAlert } from '../../../context/AlertContext';
import { useAuth } from '../../../context/AuthContext';
import BusinessHourSetup from '../../associate/schedule/components/BusinessHourSetup';


function ClientAppointmentBooking({clientId}) {
  const {AppAlert} = useAlert();

  const {authUser} =useAuth();

  const [dialogStatus, setDialogStatus] = useState(false);
  const [availableTimeSlots,setAvailableTimeSlot] = useState(null);

  const [selectedDate,setSelectedDate] = useState(null);
	const [selectedTime,setSelectedTime] = useState(null);


  const getAvailableTimeSlots = () =>{
		setSelectedTime(null);
		if(selectedDate !== null){
			setAvailableTimeSlot(null);
			let payload = {
				date: moment(selectedDate).format("YYYY-MM-DD"),
				associateId:authUser.associateId,
			}
			appointmentServices.getAvailableTimeSlots(payload).then(res=>{
				setAvailableTimeSlot(res.data);
			}).catch(error=>{
				AppAlert(error.msg,"error")
			})
		}
	}
	useEffect(()=>{
		getAvailableTimeSlots();
	},[selectedDate])

  const doSlotBooking = () =>{
    let payload ={
      clientId:clientId,
      associateId:authUser.associateId,
      selectedDate:moment(selectedDate).format("YYYY-MM-DD"),
      selectedTime:selectedTime
    }
    appointmentServices.doSlotBooking(payload).then(res=>{
      console.log(res);
      AppAlert(res.msg)
      setDialogStatus(false);
    }).catch(error=>{
      console.log(error);
      AppAlert(error.msg,"error")
    })
  }

  return (
    clientId &&
    <>
      <Dialog
        open={dialogStatus}
        keepMounted
        onClose={()=>{setDialogStatus(false)}}
        fullWidth={true}
        maxWidth="md"
        
      >
        <DialogContent
          style={{minHeight:"80vh",maxHeight:"80vh"}}
        >
          <div className='row'>
            <div className='col-md-12'>
              <BusinessHourSetup callBack={()=>getAvailableTimeSlots()} />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <Calendar 
                onChange={setSelectedDate} 
                value={selectedDate}
                minDate={moment().add(0,"day").toDate()}    
              />
            </div>
            <div className='col-md-6'>
              {!selectedTime && availableTimeSlots && availableTimeSlots.map((timeSlot,i) =>
                <div key={i} className='border rounded m-1 text-center float-start' type="button" onClick={()=>setSelectedTime(timeSlot.time)} >
                  <div className='p-1 bg-dark text-white'>{timeSlot.displayTime}</div>
                  <div className='p-1 bg-light'>{timeSlot.slots} Available</div>
                </div>
              )}
              {availableTimeSlots?.length == 0 &&
                <div className="alert alert-danger align-items-center" >
                  No Slots Available for {moment(selectedDate).format(" dddd, LL")}
                </div>
              }

              {selectedTime && 
                <div className="alert alert-success" >
                  <h3><span className='fw-bold'>Book Slot</span> <br/>{moment(selectedDate).format("dddd,LL")} <br/> {moment(selectedTime,"hh:mm:ss").format("hh:mm:A")}</h3>
                  <hr/>
                  <button className='btn btn-outline-success' onClick={()=>setSelectedTime(null)}>No Change Time</button>
                  <button className='btn btn-success float-end' onClick={doSlotBooking} >Yes Confirm!</button>
                </div>
              } 
            </div>
          </div>
          
              
             
        </DialogContent>
        
      </Dialog>
            
      <button className='btn btn-primary' onClick={()=>setDialogStatus(true)} >Book Appointment </button>
    </>
  )
}

export default ClientAppointmentBooking